<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card :loading="loading" class="mx-auto">
        <v-card-title>
          <span class="headline">ACTUALIZAR CONTRASEÑA</span>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" text @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="text--primary px-8">
          <div class="grey--text text--darken-3 px-4 pt-4">
            <ValidationObserver ref="form_datos">
              <v-col cols="12" sm="12" md="12">
                <ValidationProvider name="Clave" rules="required">
                  <v-text-field
                    v-model="passwordNew"
                    :type="mostrarClave ? 'text' : 'password'"
                    label="Nueva Contraseña"
                    slot-scope="{ errors, valid }"
                    :error-messages="errors"
                    :success="valid"
                    required
                    :append-icon="mostrarClave ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="mostrarClave = !mostrarClave"
                    prepend-icon="mdi-key"
                  ></v-text-field>
                </ValidationProvider>
                <ValidationProvider name="Confirmar Clave" rules="required">
                  <v-text-field
                    v-model="confirmarClave"
                    :type="mostrarClave ? 'text' : 'password'"
                    label="Confirmar Contraseña"
                    slot-scope="{ errors, valid }"
                    :error-messages="errors"
                    :success="valid"
                    required
                    :append-icon="mostrarClave ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="mostrarClave = !mostrarClave"
                    prepend-icon="mdi-key"
                  ></v-text-field>
                </ValidationProvider>
                <div class="v-text-field__details" v-if="validar.length">
                  <div class="v-messages theme--light error--text" role="alert">
                    <div class="v-messages__wrapper">
                      <div
                        class="v-messages__message"
                        v-for="value in validar"
                        :key="value"
                      >
                        {{ value }}
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </ValidationObserver>
          </div>
        </v-card-text>

        <v-card-actions class="pb-8 pl-8">
          <v-btn @click="save" color="primary" dark :loading="loading"
            >Guardar</v-btn
          >
          <v-btn color="warning" dark @click="cerrarModal"> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// import { mapState } from "vuex";
// import { db } from "../../firebase";
export default {
  name: "ModAddClave",
  data: () => ({
    loading: false,
    dialog: true,
    passwordNew: "",
    confirmarClave: "",
    validar: [],
    mostrarClave: false,
  }),
  props: {
    id: { type: String, default: "" },
    showModal: { type: Boolean, default: false },
  },
  async mounted() {},
  methods: {
    async save() {
      this.validar = [];
      const regex = [];
      regex.push("[A-Z]"); // For Uppercase Alphabet
      regex.push("[a-z]"); // For Lowercase Alphabet
      regex.push("[0-9]"); // For Numeric Digits
      regex.push("[$@$!%*#?&]"); // For Special Characters
      const validar = await this.$refs.form_datos.validate();
      if (!validar) return false;
      for (let i = 0; i < regex.length; i++) {
        if (!new RegExp(regex[i]).test(this.passwordNew)) {
          if (i === 0)
            this.validar.push(
              "Por lo menos debe contener una letra en mayúscula"
            );
          if (i === 1)
            this.validar.push(
              "Por lo menos debe contener una letra en minúscula"
            );
          if (i === 2)
            this.validar.push("Por lo menos debe contener un numero");
          if (i === 3)
            this.validar.push(
              "Por lo menos debe contener un carácter especial"
            );
          return;
        }
      }
      if (this.passwordNew != this.confirmarClave) {
        this.validar.push("Las contraseñas no coinciden");
        return;
      }
      const swal = await this.$swal({
        title: "Actualizar contraseña",
        text: `¿Esta seguro de actualizar?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Si, Actualizar !!",
        cancelButtonText: "No",
        cancelButtonColor: "#d33",
      });
      if (swal.isConfirmed) {
        try {
          this.loading = true;
          const headers = new Headers();
          headers.append("Content-Type", "application/json");
          const body = JSON.stringify({
            uid: this.id,
            password: this.passwordNew,
          });
          const requestOptions = {
            method: "POST",
            headers,
            body,
            redirect: "follow",
          };
          const response = await fetch(
            `${process.env.VUE_APP_CLOUDFUNCTIONURL}/ActualizarPassword`,
            requestOptions
          );
          if (!response.ok) {
            throw new Error("Algo salio mal");
          }
          this.$swal({ icon: "success", title: "Operación Exitosa", text: "" });
          this.cerrarModal();
          this.$emit("actualizar");
          this.loading = false;
        } catch (error) {
          this.handleError(error);
        }
      }
    },
    cerrarModal() {
      this.$emit("update:showModal", !this.showModal);
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.div-opciones
    overflow: auto
    height: 240px
</style>
